import React from "react";
import { HeaderWrapper } from "./style";
const Header = () => {
  return <HeaderWrapper>{/* <HeaderLogo img={BGLogo} /> */}</HeaderWrapper>;
};

export default Header;
